import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const RELATED_TRANSACTIONS_REQUEST = 'RELATED_TRANSACTIONS_REQUEST'
export const RELATED_TRANSACTIONS_SUCCESS = 'RELATED_TRANSACTIONS_SUCCESS'
export const RELATED_TRANSACTIONS_FAILURE = 'RELATED_TRANSACTIONS_FAILURE'
export const RELATED_TRANSACTIONS_RESET = 'RELATED_TRANSACTIONS_RESET'

export const fetchRelatedTransactions = (phone) => ({
  [CALL_API]: {
    endpoint: `/api/transactions/?page=1&search=${phone}`,
    types: [RELATED_TRANSACTIONS_REQUEST, RELATED_TRANSACTIONS_SUCCESS, RELATED_TRANSACTIONS_FAILURE],
    method: 'GET',
    tokenType: API_JWT_TOKEN_NAME,
  },
})

const reset = () => ({
  type: RELATED_TRANSACTIONS_RESET,
})

export const resetFetchRelatedTransactions = () => (dispatch) => dispatch(reset())
